var React = require('react');

function FrontendNavigationCc (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#000000","d":"M14.5 2h-13c-0.825 0-1.5 0.675-1.5 1.5v9c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-9c0-0.825-0.675-1.5-1.5-1.5zM1.5 3h13c0.271 0 0.5 0.229 0.5 0.5v1.5h-14v-1.5c0-0.271 0.229-0.5 0.5-0.5zM14.5 13h-13c-0.271 0-0.5-0.229-0.5-0.5v-4.5h14v4.5c0 0.271-0.229 0.5-0.5 0.5zM2 10h1v2h-1zM4 10h1v2h-1zM6 10h1v2h-1z"}));
}

FrontendNavigationCc.displayName = "FrontendNavigationCc";

FrontendNavigationCc.defaultProps = {"version":"1.1","width":"100%","height":"100%","viewBox":"0 0 16 16"};

module.exports = FrontendNavigationCc;

FrontendNavigationCc.default = FrontendNavigationCc;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/svg/menu-icons/frontend-navigation-cc.svg
// module id = 1006
// module chunks = 0